import React, {  Component } from 'react';

const ImportFileExampleImage = ({ onClose }) => {
	return (
		<React.Fragment>
			<div className='importFileExampleBackdrop' onClick={onClose} />
			<img className='importFileExampleImage' src="../images/quickorder-import-file-example.png" alt="Quick Order Import File Example Image" />
		</React.Fragment>
	);
};

export default class ImportFileConfirmOverlayDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDialog: false,
            showExampleImage: false
        }
    }

    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog && this.props.handleDialog('ImportFileConfirmOverlayDialog', false);
    }

    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }

    handleExampleImage = event => {
        event.preventDefault();
        this.setState({showExampleImage: true});
    }

    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="actionDescriptionsOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <a href='' className='pull-right bold red' onClick={this.handleExampleImage}>SEE EXAMPLE</a>
                    <h2 className="title">Import File</h2>
					<p>Only Excel or CSV files can be imported. Two columns are required and no headers should be used. The first column must contain the item number and the second column must contain the quantity.</p>
                    <p>Two additional columns of data may be included if desired. The third column (optional) can contain the sales agreement number. (The sales agreement name will not be imported.) The fourth column (optional) can contain a line level PO.</p>
					<p>Do you want to continue?</p>
					<div className="noButtonContainer">
						<a className="noButton blueButton" onClick={this.closeDialog.bind(this)}>No</a>
					</div>
					<div className="yesButtonContainer">
						<a className="yesButton blueButton" onClick={this.props.handleImportAction}>Yes</a>
					</div>
            	</div>
                {this.state.showExampleImage && <ImportFileExampleImage onClose={() => this.setState({showExampleImage: false})}/>}
			</div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/components/dialogs/importFileConfirmOverlayDialog.js